import { ShippingDocumentKind, WasteManifestSource } from "generated-graphql/graphql";

import { SourcesCell } from "../../../Manifests/SourcesCell";

/** A line's Sources pills; a bill of lading line shows only Document and Vendor. */
export function LineSourcesCell({
  row,
}: {
  row: {
    availableSources?: readonly WasteManifestSource[] | null;
    documentKind: ShippingDocumentKind;
  };
}) {
  return (
    <SourcesCell
      availableSources={row.availableSources ?? []}
      isBillOfLading={row.documentKind === ShippingDocumentKind.BillOfLading}
    />
  );
}
